import Navbar from './navbar';

export default Navbar;
